import { extractIdeasStrict, extractPostStrict, extractPostLoose } from '@/utils/chatContentParsers';
import type { PostIdea } from '@/components/chat/IdeaCards';

export interface ParsedChatContent {
  type: 'ideas' | 'post_draft' | 'post' | 'text';
  data: any;
  originalContent: string;
  originalUserPrompt?: string;
}

export const parseChatMessage = (content: string): ParsedChatContent | null => {
  try {
    const parsed = JSON.parse(content);
    
    // Check for ideas
    if (parsed?._type === 'ideas' && Array.isArray(parsed.items)) {
      return {
        type: 'ideas',
        data: parsed.items,
        originalContent: content
      };
    }
    
    // Check for post draft or post
    if ((parsed?._type === 'post_draft' || parsed?.post) && parsed.post) {
      return {
        type: 'post_draft',
        data: parsed.post,
        originalContent: content,
        originalUserPrompt: parsed.originalUserPrompt
      };
    }
    
    return null;
  } catch {
    return null;
  }
};

export const extractCardData = (content: string): { ideas?: PostIdea[]; post?: any } | null => {
  try {
    const parsed = JSON.parse(content);
    
    if (parsed?._type === 'ideas' && Array.isArray(parsed.items)) {
      return { ideas: parsed.items };
    }
    
    if ((parsed?._type === 'post_draft' || parsed?.post) && parsed.post) {
      return { post: parsed.post };
    }
    
    return null;
  } catch {
    return null;
  }
};

export const isCardContent = (content: string): boolean => {
  const parsed = parseChatMessage(content);
  return parsed !== null;
};

export const getCardType = (content: string): "ideas" | "post_draft" | "post" | "text" => {
  const parsed = parseChatMessage(content);
  if (!parsed) return 'text';
  return parsed.type;
};

export const renderCardContent = (content: string, onCreateOutline?: (idea: PostIdea) => void) => {
  const parsed = parseChatMessage(content);
  if (!parsed) return null;
  
  if (parsed.type === 'ideas') {
    return {
      type: 'ideas',
      data: parsed.data,
      component: 'IdeaCards'
    };
  }
  
  if (parsed.type === 'post_draft') {
    return {
      type: 'post_draft',
      data: parsed.data,
      component: 'PostDraftCard'
    };
  }
  
  return null;
};
